import { combineReducers } from 'redux'

import menu from './menu'
import widgets from './widgets'

export default combineReducers({
  menu,
  widgets,
})
